export const refillKeys = {
    refill: ["refill"] as const,
    refillsById: (id: string) => [...refillKeys.refill, "refills-by-id", id] as const,
    approveRefillRequest: (id: string) => [...refillKeys.refill , "approve-refill", id] as const,
    rejectRefillRequest: (id: string) => [...refillKeys.refill, "reject-refill", id] as const,  
}